import type { ReactNode } from "react";
import {
  RegistrationStatus,
  useCheckUserRegistrationApi,
} from "../../api/authorization-api";
import AccessRequestPage from "../../pages/AccessRequestPage";
import Spinner from "../Spinner";

interface RegistrationGuardProps {
  children: ReactNode;
}

export function RegistrationGuard({ children }: RegistrationGuardProps) {
  const { data: status, isLoading } = useCheckUserRegistrationApi();

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "calc(100vh - 8rem)",
        }}
      >
        <Spinner />
      </div>
    );
  }

  if (
    status === RegistrationStatus.NotRegistered ||
    status === RegistrationStatus.PendingRegistration
  ) {
    return <AccessRequestPage status={status} />;
  }

  return <>{children}</>;
}

export default RegistrationGuard;
